"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGenericReducer = exports.createDefaultActionCreators = exports.createDefaultService = exports.createGenericInitialState = exports.GenericModelPage = void 0;
var redux_react_router_1 = require("@lagunovsky/redux-react-router");
var models_1 = require("@scrubtech/models");
var ui_reducer_1 = require("@scrubtech/ui-reducer");
var redux_loop_1 = require("redux-loop");
var utils_1 = require("../utils/utils");
var GenericModelPage = /** @class */ (function () {
    function GenericModelPage() {
        this.error = null;
        this.isFetching = false;
        this.childIDs = [];
        this.paginationInfo = new models_1.PaginationInfo();
        this.isInitialized = false;
    }
    return GenericModelPage;
}());
exports.GenericModelPage = GenericModelPage;
var createGenericInitialState = function () { return ({
    byID: {},
    pages: {},
    isFetchingByID: {},
    errorByID: {},
    selectedEntity: null,
    loading: false,
    error: null,
}); };
exports.createGenericInitialState = createGenericInitialState;
var createDefaultService = function () { return ({
    fetchAll: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ({ items: [], paginationInfo: new models_1.PaginationInfo() })];
    }); }); },
    fetchByID: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ({})];
    }); }); },
    create: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ({})];
    }); }); },
    update: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ({})];
    }); }); },
    delete: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ({})];
    }); }); },
}); };
exports.createDefaultService = createDefaultService;
var createDefaultActionCreators = function () { return ({
    resolveFetchAll: function () { return ({ type: '' }); },
    rejectFetchAll: function () { return ({ type: '' }); },
    resolveFetchByID: function () { return ({ type: '' }); },
    rejectFetchByID: function () { return ({ type: '' }); },
    resolveCreate: function () { return ({ type: '' }); },
    rejectCreate: function () { return ({ type: '' }); },
    resolveUpdate: function () { return ({ type: '' }); },
    rejectUpdate: function () { return ({ type: '' }); },
    resolveDelete: function () { return ({ type: '' }); },
    rejectDelete: function () { return ({ type: '' }); },
}); };
exports.createDefaultActionCreators = createDefaultActionCreators;
var createSuccessMessages = function (entityName) { return ({
    create: "".concat(entityName, " created successfully"),
    update: "".concat(entityName, " updated successfully"),
    delete: "".concat(entityName, " deleted successfully"),
}); };
/**
 * Creates a generic reducer for a specific model type
 * @template T - The entity type the reducer will manage
 * @template RequestParams - The type of request parameters used for API calls
 * @param config - Configuration options for the reducer
 * @param initialState - The initial state for the reducer
 * @returns A reducer function that handles all standard CRUD operations
 */
var createGenericReducer = function (config, initialState) {
    return function (state, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        if (state === void 0) { state = initialState; }
        var actionTypes = config.actionTypes, _x = config.service, service = _x === void 0 ? (0, exports.createDefaultService)() : _x, _y = config.actionCreators, actionCreators = _y === void 0 ? (0, exports.createDefaultActionCreators)() : _y, _z = config.extractEntities, extractEntities = _z === void 0 ? function (response) { return response.items; } : _z, getEntityID = config.getEntityID, entityName = config.entityName, _0 = config.customActionHandlers, customActionHandlers = _0 === void 0 ? {} : _0, navigationConfig = config.navigationConfig;
        var successMessages = createSuccessMessages(entityName);
        // Use the provided generatePageKey or fall back to the default common utility
        var generatePageKey = config.generatePageKey || utils_1.generatePageKey;
        // Then check for custom action handlers
        if (customActionHandlers[action.type]) {
            return customActionHandlers[action.type](state, action);
        }
        switch (action.type) {
            case actionTypes.FETCH_ALL: {
                var success = action.success;
                switch (success) {
                    case undefined: {
                        var payload_1 = (action === null || action === void 0 ? void 0 : action.payload) || {};
                        var pageObject = new GenericModelPage();
                        pageObject.isFetching = true;
                        pageObject.isInitialized = true;
                        var pageKey = generatePageKey(payload_1);
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { loading: true, error: null, pages: __assign(__assign({}, state.pages), (_a = {}, _a[pageKey] = pageObject, _a)) }), redux_loop_1.Cmd.run(service.fetchAll, {
                            successActionCreator: function (response) { return actionCreators.resolveFetchAll(response, payload_1); },
                            failActionCreator: function (error) { return actionCreators.rejectFetchAll(error, payload_1); },
                            args: [payload_1],
                        }));
                    }
                    case true: {
                        var payload = action.payload;
                        var entities = extractEntities(payload);
                        var pageKey = generatePageKey(payload.requestParams);
                        // Update byID with new entities
                        var byID_1 = __assign({}, state.byID);
                        entities.forEach(function (entity) {
                            var id = getEntityID(entity);
                            byID_1[id] = entity;
                        });
                        // Update page with new entities
                        var page = __assign(__assign({}, state.pages[pageKey]), { childIDs: entities.map(getEntityID), paginationInfo: payload.paginationInfo, isFetching: false });
                        return __assign(__assign({}, state), { byID: byID_1, pages: __assign(__assign({}, state.pages), (_b = {}, _b[pageKey] = page, _b)), loading: false, error: null });
                    }
                    case false: {
                        var payload = action.payload;
                        var pageKey = generatePageKey(payload.requestParams);
                        return __assign(__assign({}, state), { loading: false, error: payload.error, pages: __assign(__assign({}, state.pages), (_c = {}, _c[pageKey] = __assign(__assign({}, state.pages[pageKey]), { error: payload.error, isFetching: false }), _c)) });
                    }
                }
            }
            case actionTypes.FETCH_BY_ID: {
                var success = action.success;
                switch (success) {
                    case undefined: {
                        var payload_2 = action.payload;
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { isFetchingByID: __assign(__assign({}, state.isFetchingByID), (_d = {}, _d[payload_2] = true, _d)), errorByID: __assign(__assign({}, state.errorByID), (_e = {}, _e[payload_2] = null, _e)) }), redux_loop_1.Cmd.run(service.fetchByID, {
                            successActionCreator: function (response) { return actionCreators.resolveFetchByID(response); },
                            failActionCreator: function (error) { return actionCreators.rejectFetchByID(error, payload_2); },
                            args: [payload_2],
                        }));
                    }
                    case true: {
                        var entity = action.payload;
                        var id = getEntityID(entity);
                        return __assign(__assign({}, state), { byID: __assign(__assign({}, state.byID), (_f = {}, _f[id] = entity, _f)), selectedEntity: entity, isFetchingByID: __assign(__assign({}, state.isFetchingByID), (_g = {}, _g[id] = false, _g)), errorByID: __assign(__assign({}, state.errorByID), (_h = {}, _h[id] = null, _h)) });
                    }
                    case false: {
                        var payload = action.payload;
                        return __assign(__assign({}, state), { isFetchingByID: __assign(__assign({}, state.isFetchingByID), (_j = {}, _j[payload.id] = false, _j)), errorByID: __assign(__assign({}, state.errorByID), (_k = {}, _k[payload.id] = payload.error, _k)) });
                    }
                }
            }
            case actionTypes.CREATE: {
                var success = action.success;
                switch (success) {
                    case undefined: {
                        var payload_3 = action.payload;
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { loading: true, error: null }), redux_loop_1.Cmd.run(service.create, {
                            successActionCreator: function (response) { return actionCreators.resolveCreate(response); },
                            failActionCreator: function (error) { return actionCreators.rejectCreate(error, payload_3); },
                            args: [payload_3],
                        }));
                    }
                    case true: {
                        var entity = action.payload;
                        var id = getEntityID(entity);
                        var commands = [
                            redux_loop_1.Cmd.action((0, ui_reducer_1.flash)(successMessages.create, ui_reducer_1.FlashMessageType.Success)),
                        ];
                        // If navigation config is provided, add navigation command
                        if (navigationConfig === null || navigationConfig === void 0 ? void 0 : navigationConfig.getPostCreationUrl) {
                            commands.push(redux_loop_1.Cmd.action((0, redux_react_router_1.push)(navigationConfig.getPostCreationUrl(entity))));
                        }
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { byID: __assign(__assign({}, state.byID), (_l = {}, _l[id] = entity, _l)), isFetchingByID: __assign(__assign({}, state.isFetchingByID), (_m = {}, _m[-1] = false, _m)), selectedEntity: entity, loading: false }), redux_loop_1.Cmd.list(commands));
                    }
                    case false: {
                        var payload = action.payload;
                        var error = payload.error;
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { isFetchingByID: __assign(__assign({}, state.isFetchingByID), (_o = {}, _o[-1] = false, _o)), errorByID: __assign(__assign({}, state.errorByID), (_p = {}, _p[-1] = payload.error, _p)), loading: false, error: payload.error }), redux_loop_1.Cmd.action((0, ui_reducer_1.flash)(error.error.message, ui_reducer_1.FlashMessageType.Error)));
                    }
                }
            }
            case actionTypes.UPDATE: {
                var success = action.success;
                switch (success) {
                    case undefined: {
                        var payload_4 = action.payload;
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { loading: true, error: null }), redux_loop_1.Cmd.run(service.update, {
                            successActionCreator: function (response) { return actionCreators.resolveUpdate(response); },
                            failActionCreator: function (error) { return actionCreators.rejectUpdate(error, payload_4.id, payload_4.data); },
                            args: [payload_4.id, payload_4.data],
                        }));
                    }
                    case true: {
                        var entity = action.payload;
                        var id = getEntityID(entity);
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { byID: __assign(__assign({}, state.byID), (_q = {}, _q[id] = entity, _q)), isFetchingByID: __assign(__assign({}, state.isFetchingByID), (_r = {}, _r[id] = false, _r)), selectedEntity: entity, loading: false }), redux_loop_1.Cmd.action((0, ui_reducer_1.flash)(successMessages.update, ui_reducer_1.FlashMessageType.Success)));
                    }
                    case false: {
                        var payload = action.payload;
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { isFetchingByID: __assign(__assign({}, state.isFetchingByID), (_s = {}, _s[payload.id] = false, _s)), errorByID: __assign(__assign({}, state.errorByID), (_t = {}, _t[payload.id] = payload.error, _t)), loading: false, error: payload.error }), redux_loop_1.Cmd.action((0, ui_reducer_1.flash)(payload.error.error.message, ui_reducer_1.FlashMessageType.Error)));
                    }
                }
            }
            case actionTypes.DELETE: {
                var success = action.success;
                switch (success) {
                    case undefined: {
                        var payload_5 = action.payload;
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { loading: true, error: null }), redux_loop_1.Cmd.run(service.delete, {
                            successActionCreator: function (response) { return actionCreators.resolveDelete(response); },
                            failActionCreator: function (error) { return actionCreators.rejectDelete(error, payload_5); },
                            args: [payload_5],
                        }));
                    }
                    case true: {
                        var entity = action.payload;
                        var id_1 = getEntityID(entity);
                        // Remove from byID
                        var byID = __assign({}, state.byID);
                        delete byID[id_1];
                        // Remove from all pages
                        var pages_1 = __assign({}, state.pages);
                        Object.keys(pages_1).forEach(function (pageKey) {
                            pages_1[pageKey] = __assign(__assign({}, pages_1[pageKey]), { childIDs: pages_1[pageKey].childIDs.filter(function (childID) { return childID !== id_1; }) });
                        });
                        var commands = [
                            redux_loop_1.Cmd.action((0, ui_reducer_1.flash)(successMessages.delete, ui_reducer_1.FlashMessageType.Success)),
                        ];
                        // If navigation config is provided, add navigation command
                        if (navigationConfig === null || navigationConfig === void 0 ? void 0 : navigationConfig.getPostDeletionUrl) {
                            commands.push(redux_loop_1.Cmd.action((0, redux_react_router_1.push)(navigationConfig.getPostDeletionUrl())));
                        }
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { byID: byID, pages: pages_1, isFetchingByID: __assign(__assign({}, state.isFetchingByID), (_u = {}, _u[id_1] = false, _u)), selectedEntity: null, loading: false }), redux_loop_1.Cmd.list(commands));
                    }
                    case false: {
                        var payload = action.payload;
                        return (0, redux_loop_1.loop)(__assign(__assign({}, state), { isFetchingByID: __assign(__assign({}, state.isFetchingByID), (_v = {}, _v[payload.id] = false, _v)), errorByID: __assign(__assign({}, state.errorByID), (_w = {}, _w[payload.id] = payload.error, _w)), loading: false, error: payload.error }), redux_loop_1.Cmd.action((0, ui_reducer_1.flash)(payload.error.error.message, ui_reducer_1.FlashMessageType.Error)));
                    }
                }
            }
            case actionTypes.CLEAR_SELECTED: {
                return __assign(__assign({}, state), { selectedEntity: null });
            }
            case actionTypes.CLEAR_ERROR: {
                return __assign(__assign({}, state), { error: null });
            }
            default:
                return state;
        }
    };
};
exports.createGenericReducer = createGenericReducer;
